/**
 * Module-level sync status store — same idiom as the `flushListeners`
 * pub/sub in `useSync.ts` (one instance app-wide, so a plain external
 * store is enough; no React context needed). Exposes the streak count
 * from the most recent `bootstrap` response so screens like `Today` can
 * render it via `useSyncExternalStore` without threading it through
 * props or re-fetching.
 */

// `useSyncExternalStore` requires `getSnapshot` to return a referentially
// stable value when nothing has changed (otherwise it re-renders forever) —
// so the snapshot object is cached and only replaced when `streak` changes.
let snapshot: { streak: number | null } = { streak: null };
const listeners = new Set<() => void>();

/** Current snapshot, for `useSyncExternalStore`'s `getSnapshot`. */
export function getSnapshot(): { streak: number | null } {
  return snapshot;
}

/** Subscribe to changes, for `useSyncExternalStore`'s `subscribe`. */
export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Set the streak (called by `useSync` after a successful bootstrap). */
export function setStreak(next: number | null): void {
  if (next === snapshot.streak) return;
  snapshot = { streak: next };
  for (const listener of listeners) listener();
}
